export type Environment = "production" | "preview" | "development" | "test" | "storybook";

interface EnvironmentOptions {
  mode?: string;
  hostname?: string;
  storybook?: boolean;
}

// Vite's PROD flag describes an optimized build, not a production deployment.
export const getEnvironment = ({
  mode = import.meta.env.MODE,
  hostname = typeof window === "undefined" ? "" : window.location.hostname,
  storybook = Boolean(import.meta.env.STORYBOOK) ||
    (typeof window !== "undefined" && Boolean((window as Window & { DOCS_OPTIONS?: unknown }).DOCS_OPTIONS)),
}: EnvironmentOptions = {}): Environment => {
  if (storybook) {
    return "storybook";
  }

  const host = hostname.toLowerCase().replace(/\.$/, "");
  if (host === "preview.wayflyer.net" || host.endsWith(".preview.wayflyer.net")) {
    return "preview";
  }

  if (mode === "test") {
    return "test";
  }

  if (
    mode === "production" &&
    (host === "wayflyer.com" || host.endsWith(".wayflyer.com") || host === "app.wayflyer.team")
  ) {
    return "production";
  }

  return "development";
};

export const isProductionEnvironment = (options?: EnvironmentOptions): boolean =>
  getEnvironment(options) === "production";
export const isDevEnv = (): boolean => !isProductionEnvironment();
